module.exports = __webpack_public_path__ + "img/pakistan.dc24a5fa.svg";